import { render } from "./TheDeviceDetails.vue?vue&type=template&id=af32059a"
import script from "./TheDeviceDetails.vue?vue&type=script&lang=js"
export * from "./TheDeviceDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__